import * as stylex from "@stylexjs/stylex";
import useLocale from "hooks/useLocale";
import { ArrowLeft14 } from "icons/ArrowLeft";
import Link from "next/link";
import { O, pipe } from "prelude";
import { FormattedMessage } from "react-intl";
import { findArticleAlias, useAlias } from "routes";
import { useChartType } from "../../domain/hero-state";
import { useMedia, useThemeNavigation } from "../../hooks";
import { breakpoints, colors } from "../../materials/consts.stylex";
import { Button, ButtonGroup } from "../button";
import { DownloadButton, InfoButton, ShareButton } from "../tooltip-triggers";
const Divider = ()=>{
    return <div className="x10w6t97 x1i1rx1s x15uhsjy xg01cxk x1208bl2 x1s85apg x1opy629"/>;
};
const HeroControls = ({ id, caption, content, csv, xlsx, source, hideToggle, embed, dataset })=>{
    const [chartType, setChartType] = useChartType();
    const isToday = chartType === "today";
    const screenMDown = !useMedia(breakpoints.m);
    const locale = useLocale();
    const isArabic = locale === "ar";
    const alias = useAlias();
    const aliasRoute = pipe(findArticleAlias(alias), O.toUndefined);
    const [prevTheme, nextTheme] = useThemeNavigation(aliasRoute);
    const iconControls = <div className="x78zum5 xou54vl xozqiw3">
      {!embed && <div className="x1td3qas x10w6t97 x12fzoxp x12klvby x1n3tk9q x1ypdohk x268jtm">
          <InfoButton content={content} source={source} gray/>
        </div>}
      <div className="x1td3qas x10w6t97 x12fzoxp x12klvby x1n3tk9q x1ypdohk x268jtm">
        <DownloadButton id={id} csv={csv} xlsx={xlsx} gray/>
      </div>
      <div className="x1td3qas x10w6t97 x12fzoxp x12klvby x1n3tk9q x1ypdohk x268jtm">
        <ShareButton id={id} message={caption} gray dataset={dataset}/>
      </div>
    </div>;
    const rootProps = {
        0: {
            className: "x1rmmofs x78zum5 x1qughib x1cy8zhl xou54vl xqui205 x1ykq3wk xj3b58b x12m30dx xdt5ytf xpohigx"
        },
        1: {
            className: "x1rmmofs x78zum5 x1cy8zhl xou54vl xqui205 x1ykq3wk xdt5ytf xpohigx x1nhvcw1 xj3b58b x1hq5gj4"
        }
    }[!!embed << 0];
    return <div {...rootProps} className={`hero-controls-root ${rootProps.className}`}>
      {embed && <>
          {iconControls} {!hideToggle && <Divider/>}
        </>}

      <div className={`hero-controls-buttons ${({
        className: "x98rzlu xh8yej3 x17ngzzj x1x1rfll x1tz2wgx"
    }).className}`}>
        {!hideToggle && <ButtonGroup>
            <Button inverted={!isToday} onClick={()=>setChartType("today")}>
              <FormattedMessage id="Today" defaultMessage="Today"/>
            </Button>
            <Button inverted={isToday} onClick={()=>setChartType("timeseries")}>
              <FormattedMessage id="Time series" defaultMessage="Time series"/>
            </Button>
          </ButtonGroup>}
      </div>
      {screenMDown ? <div className="xh8yej3 x78zum5 xou54vl x1qughib">
          <div>{!embed && iconControls}</div>
          {prevTheme && nextTheme && <div className="x78zum5 xou54vl xozqiw3">
              <Link href={`/articles/${prevTheme}`} className="x12fzoxp x1n3tk9q x268jtm x3nfvp2 xl56j7k x6s0dn4 x2lah0s x1td3qas x10w6t97 x1hcezkj x1ypdohk x1t137rt">
                <ArrowLeft14 {...{
        0: {},
        1: {
            className: "x19jd1h0"
        }
    }[!!isArabic << 0]}/>
              </Link>
              <Link href={`/articles/${nextTheme}`} className="x12fzoxp x1n3tk9q x268jtm x3nfvp2 xl56j7k x6s0dn4 x2lah0s x1td3qas x10w6t97 x1hcezkj x1ypdohk x1t137rt">
                <ArrowLeft14 {...{
        0: {
            className: "x19jd1h0"
        },
        1: {
            className: "x7p49u4"
        }
    }[!!isArabic << 0]}/>
              </Link>
            </div>}
        </div> : !embed && iconControls}
    </div>;
};
export const HeroControlsWrapper = ({ children, renderMode, caption, content, source, id, csv, xlsx, hideToggle, dataset })=>{
    const embed = renderMode === "embed";
    const controls = <HeroControls caption={caption} content={content} source={source} id={id} csv={csv} xlsx={xlsx} hideToggle={hideToggle} embed={embed} dataset={dataset}/>;
    return <>
      {embed && controls}
      {children}
      {!embed && renderMode !== "static" && controls}
    </>;
};
